import type { MpfAppHeaderProps } from './MpfAppHeader.props';

export const mpfAppHeaderDefaults: Partial<MpfAppHeaderProps> = {
  isNhsWebApp: false,
  isTenantLoaded: false,
  tenantId: null,
  tenantName: 'NHS England',
};
